import { makeIconDef } from "./makeIconDef";

export const BlankIconDef = {
  blank: makeIconDef("blank", {
    regular: () => <></>,
    filled: () => <></>,
  }),
};
